// External packages
import { useNavigate } from 'react-router-dom';
import * as React from 'react';
import { z } from 'zod';

// Components
import { Form, InputField } from 'components/Form';
import { Button } from 'components/Button';
import { Layout } from 'components/Layout';

// Hooks
import { useLogin } from 'api/auth';

const loginFormSchema = z.object({
  email: z
    .string({ message: 'Unesite email' })
    .email({ message: 'Uneseni email nije ispravan' })
    .min(1, { message: 'Unesite email' }),
  password: z
    .string({ message: 'Unesite lozinku' })
    .min(1, { message: 'Unesite lozinku' }),
});

export default function LoginPage() {
  const navigate = useNavigate();
  const { mutate: loginMutation, isPending: isLoggingIn } = useLogin();

  const onSubmit = (values: { email: string; password: string }) => {
    loginMutation(values, {
      onSuccess: () => {
        navigate('/eksponati');
      },
    });
  };

  return (
    <Layout>
      <div className="col-span-full flex h-screen flex-col items-center justify-center">
        <div className="w-full max-w-md rounded-lg bg-gray-50 px-10 py-12 shadow-md">
          <Form
            schema={loginFormSchema}
            onSubmit={onSubmit}
            className="space-y-6"
          >
            <InputField
              isRequired
              inputProps={{
                colorScheme: 'white',
              }}
              name="email"
              label="Email"
            />
            <InputField
              isRequired
              inputProps={{
                colorScheme: 'white',
                type: 'password',
              }}
              name="password"
              label="Lozinka"
            />
            <Button type="submit" className="w-full" isPending={isLoggingIn}>
              Prijava
            </Button>
          </Form>
        </div>
      </div>
    </Layout>
  );
}
